<div class="text-center">
    <button class="btn btn-secondary btn-sm" (click)="openConnectAs()">
        <nb-icon icon="fa-sign-in-alt"></nb-icon>
    </button>
</div>
